import React from 'react'
import './Leadership.css'
import { images } from '../../../assets'

function Leadership() {
  return (
    <div className='leadership'>
      <div className='leadershipcard'>
        <div className='leadershipheading'>
        Leadership
        </div>
        <div className='leadershipprofile'>
            <div className='leadershipphoto'>
                <img src={images.leadership} alt='leadership' />
            </div>
            <div className='leadershipname'>
                <div className='leadershipname1'>
                    <div className='leadershipn1'>Nikhil Khandelwal</div>
                    <div className='leadershipdesig'>Cofounder, Product Head</div>

                </div>
                <div className='leadershipname1'>
                    <div className='leadershipn1'>Ishan Nadkarni</div>
                    <div className='leadershipdesig'>Cofounder, CEO</div>

                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Leadership
